// Remove the "Store" option from Judge.me's native write-review product selector.
// The custom reviews form (component-page-reviews.js) handles its own selector separately.
(function removeJudgeMeStoreOption() {
  function _purge() {
    document.querySelectorAll('[class*="jdgm"] select option').forEach(function (opt) {
      if (opt.textContent.trim().toLowerCase() === 'store') opt.remove();
    });
  }

  var observer = new MutationObserver(_purge);
  observer.observe(document.body, { childList: true, subtree: true });
}());

// Clean up Shopify recommendation tracking params from the URL on page load.
// Shopify appends pr_* params when navigating from cross-sell / recommendation blocks.
// The tracking request is already sent by the time this runs, so analytics are preserved.
(function cleanRecommendationParams() {
  const TRACKING_PARAMS = ['pr_prod_strat', 'pr_rec_id', 'pr_rec_pid', 'pr_ref_pid', 'pr_seq', 'variant'];
  const url = new URL(window.location.href);
  const hasTracking = TRACKING_PARAMS.some((p) => url.searchParams.has(p));
  if (!hasTracking) return;
  TRACKING_PARAMS.forEach((p) => url.searchParams.delete(p));
  const clean = url.pathname + (url.search || '') + (url.hash || '');
  history.replaceState(null, '', clean);
}());
